import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { BaseballFixture, BaseballPeriod } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';
import GameTime from '../GameTime/GameTime';

import {
  TXTWCL_1st_Inning,
  TXTWCL_2nd_Inning,
  TXTWCL_3rd_Inning,
  TXTWCL_4th_Inning,
  TXTWCL_5th_Inning,
  TXTWCL_6th_Inning,
  TXTWCL_7th_Inning,
  TXTWCL_8th_Inning,
  TXTWCL_9th_Inning,
  TXTWCL_Extra_Innings,
  TXTWCL_Game_Ended,
  TXTWCL_Going_In_PlayXX,
  TXTWCL_Unknown_1
} from './BaseballScoreboardInPlayStatus.messages.json';

const translationMap: Record<BaseballPeriod, TranslationTag> = {
  INNING_1: TXTWCL_1st_Inning,
  INNING_2: TXTWCL_2nd_Inning,
  INNING_3: TXTWCL_3rd_Inning,
  INNING_4: TXTWCL_4th_Inning,
  INNING_5: TXTWCL_5th_Inning,
  INNING_6: TXTWCL_6th_Inning,
  INNING_7: TXTWCL_7th_Inning,
  INNING_8: TXTWCL_8th_Inning,
  INNING_9: TXTWCL_9th_Inning,
  EXTRA_INNINGS: TXTWCL_Extra_Innings,
  END: TXTWCL_Game_Ended,
  PRE_MATCH: TXTWCL_Going_In_PlayXX,
  UNKNOWN: TXTWCL_Unknown_1
};

interface Props {
  baseballFixture: BaseballFixture;
}

const BaseballScoreboardInPlayStatus: React.FC<Props> = ({ baseballFixture }) => {
  const { score, clock } = baseballFixture;
  if (!score || !clock) {
    return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }

  switch (clock.period) {
    case 'END':
    case 'INNING_1':
    case 'INNING_2':
    case 'INNING_3':
    case 'INNING_4':
    case 'INNING_5':
    case 'INNING_6':
    case 'INNING_7':
    case 'INNING_8':
    case 'INNING_9':
    case 'EXTRA_INNINGS':
      return (
        <GameTime>
          <span>
            <Translation {...translationMap[clock.period]} />
          </span>
        </GameTime>
      );
    default:
      return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }
};

export default BaseballScoreboardInPlayStatus;
